// Shared exotics-pricer constants. Extracted from index.tsx so the handoff
// bridge can enforce the same instrument cap without importing the page
// component (which would be a cycle — the page imports the bridge).

// How many instrument columns a fresh tab seeds with.
export const DEFAULT_INSTRUMENT_COUNT = 3;

// Maximum instruments per tab. Raised 8 -> 20 (IM-1955) so a trader can build
// a basket off the Market Probabilities ladder. calculateAll sends ONE
// generic_pricer request PER instrument (sequential PV, then parallel ladders)
// — there is no batched per-request limit — so the ceiling is purely a guard
// against queuing many heavy solves (each instrument is a 2F-PDE solve under
// SV), not a wire constraint.
export const MAX_INSTRUMENTS = 20;
